module.exports = __webpack_public_path__ + "static/entrepreneurs-group-08d72eca6b62ae70bdd0e7dfd73a0dd7.jpg";